import React from 'react';
import SalesList from './SalesList';

const CancelledSalesPage = () => {
  return <SalesList defaultTab="cancelled" />;
};

export default CancelledSalesPage;
